export class RunningCostQuery {
    constructor(
        public fuel_type: 'petrol' | 'diesel',
        public mpg: number,
        public annual_tax_cost: number,
        public annual_mileage: number = 0
    ) { }

}